import css from './form.module.scss';

import cx from 'classnames';
import { InputHTMLAttributes, TextareaHTMLAttributes } from 'react';

import { Input } from '../Input';
import LangIcon from '../LangIcon';
import { Textarea as TextareaUI } from '../Textarea';

type CompWithChildren<T = object> = React.FC<{ children: React.ReactNode } & T>;

export const Textarea: React.FC<
  TextareaHTMLAttributes<HTMLTextAreaElement> & {
    invalid?: boolean;
    autoSize?: boolean;
  }
> = ({ invalid, autoSize, ...props }) => (
  <TextareaUI
    {...props}
    autoSize={autoSize}
    className={cx(css.textarea, props.className, invalid && css.invalid)}
  />
);

export const ActionsRow: CompWithChildren = ({ children }) => (
  <div className={css.actionRows}>{children}</div>
);

export const FormGroup: CompWithChildren<{ title: string }> = ({
  children,
  title,
}) => (
  <div className={css.formGroup}>
    <div className={css.formGroupTitle}>{title}</div>
    {children}
  </div>
);

export const FormInput: React.FC<
  InputHTMLAttributes<HTMLInputElement>
> = props => <Input {...props} className={cx(css.input, props.className)} />;

export const FormSelect: React.FC<
  InputHTMLAttributes<HTMLSelectElement>
> = props => <select {...props} className={cx(css.select, props.className)} />;

type TInputProps = InputHTMLAttributes<HTMLInputElement>;
export const LangInput: React.FC<TInputProps & { lang: TLangAndNone }> = ({
  lang,
  ...props
}) => (
  <div className={css.langInput}>
    {lang !== 'none' && <LangIcon className={css.langIcon} lang={lang} />}
    <FormInput className={css.textInput} {...props} />
  </div>
);

export const FormCheckbox: React.FC<
  InputHTMLAttributes<HTMLInputElement> & { label: string }
> = props => (
  <label className={cx(props.className, css.checkBox)}>
    <input type="checkbox" {...props} />{' '}
    <span className={css.checkBoxLabel}>{props.label}</span>
  </label>
);
